import { createAction, props } from '@ngrx/store';
import { UserDetail } from '../../models/UserDetail.model';
import { VehicleWithImagesResponseDto, VehicleQueryParams } from '../../services/vehicle.service';

// Load Users Actions
export const loadUsers = createAction('[Garage] Load Users');

export const loadUsersSuccess = createAction(
  '[Garage] Load Users Success',
  props<{ users: UserDetail[] }>()
);

export const loadUsersFailure = createAction(
  '[Garage] Load Users Failure',
  props<{ error: any }>()
);

// Search Users Actions
export const searchUsers = createAction(
  '[Garage] Search Users',
  props<{ pageNum: number; pageSize: number; query?: string }>()
);

export const searchUsersSuccess = createAction(
  '[Garage] Search Users Success',
  props<{ users: UserDetail[] }>()
);

export const searchUsersFailure = createAction(
  '[Garage] Search Users Failure',
  props<{ error: any }>()
);

// Clear Users
export const clearUsers = createAction('[Garage] Clear Users');

// Load Vehicles Actions
export const loadVehicles = createAction(
  '[Garage] Load Vehicles',
  props<{ params?: VehicleQueryParams }>()
);

export const loadVehiclesSuccess = createAction(
  '[Garage] Load Vehicles Success',
  props<{
    vehicles: VehicleWithImagesResponseDto[];
    currentPage: number;
    pageSize: number;
    totalPages: number;
  }>()
);

export const loadVehiclesFailure = createAction(
  '[Garage] Load Vehicles Failure',
  props<{ error: any }>()
);

// Clear Vehicles
export const clearVehicles = createAction('[Garage] Clear Vehicles');

// Load Vehicle Detail Actions
export const loadVehicleDetail = createAction(
  '[Garage] Load Vehicle Detail',
  props<{ vehicleId: string }>()
);

export const loadVehicleDetailSuccess = createAction(
  '[Garage] Load Vehicle Detail Success',
  props<{ vehicleId: string; vehicle: VehicleWithImagesResponseDto }>()
);

export const loadVehicleDetailFailure = createAction(
  '[Garage] Load Vehicle Detail Failure',
  props<{ vehicleId: string; error: any }>()
);

// Update Vehicle in List Action
export const updateVehicleInList = createAction(
  '[Garage] Update Vehicle In List',
  props<{ vehicle: VehicleWithImagesResponseDto }>()
);
